export default "__VITE_ASSET__d1e023fe__"